/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { FiltersProvider } from '@mercadoni/sinister/dist/cjs/filters/context'
import { useSearchEvent } from '@mercadoni/sinister/dist/cjs/monitors/hooks'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { Store } from '@mercadoni/sinister/dist/lib/src/entities/store'
import { useRouter } from 'next/navigation'
import SearchLayout from './SearchLayout'
import SearchLogic from './SearchLogic'
import { getBannerGTMAdsAnalyticsInfo } from './utils/bannerInfoForAnalytics'

const Search = ({
  clientModel,
  store,
  revalidatePath,
  userAgent,
  googleAnalyticsSessionId,
}: {
  clientModel: any
  store: Store
  revalidatePath: (url: string) => Promise<void>
  userAgent?: string
  googleAnalyticsSessionId?: string
}) => {
  const {
    clientId,
    theme,
    filtersIcons,
    enabledAds,
    adsBanners = {},
    sortOptions,
  } = clientModel
  const { filter: copy } = getLocale() || defaultLocale
  const router = useRouter()
  const { sendSearchEvents } = useSearchEvent()
  const [isMobile] = useIsMobile(userAgent)

  const onSearchEvents = (params: any) => {
    const adUnit = enabledAds && adsBanners?.search?.path
    sendSearchEvents({
      ...params,
      ...getBannerGTMAdsAnalyticsInfo({
        adUnit,
        index: 0,
      }),
    })
  }

  const handleRouterChange = async (url: string) => {
    await revalidatePath(url)
    await router.push(url)
  }

  return (
    <FiltersProvider
      store={store}
      copy={copy}
      clientId={clientId}
      theme={theme}
      onSearchEvents={onSearchEvents}
      sortOptionsConfig={sortOptions}
      googleAnalyticsSessionId={googleAnalyticsSessionId}
    >
      <SearchLogic
        Wrapper={SearchLayout}
        filtersIcons={filtersIcons}
        onRouterChange={handleRouterChange}
        isMobile={isMobile}
      />
    </FiltersProvider>
  )
}

export default Search
